// Public assembly point for the engine's built-in op schemas. Imports
// the per-domain schemas from sibling modules, composes them into the
// canonical `builtins` array consumed by the evaluator and
// `defineScope`, and re-exports the small set of cross-package helpers
// (`defineFold`, `validateColumnPath`) and scope objects so plugin
// authors and tests have a single import target.
//
// Section files (arithmetic.ts, comparison.ts, …) hold the ops; this
// file exists purely to compose them.

import {
  abs,
  ceil,
  divide,
  exp,
  floor,
  log,
  maxOp,
  minOp,
  minus,
  mod,
  neg,
  plus,
  pow,
  round,
  sqrt,
  times,
} from './arithmetic.ts';
import { def, fnOp, letOp } from './binding.ts';
import { and, not, or } from './boolean.ts';
import { colOpForm } from './col.ts';
import { equals, greater, greaterEq, inOp, lessEq, lessThan, notEquals } from './comparison.ts';
import { caseOp, ifOp, nullIf } from './conditional.ts';
import { materializeOpForm } from './materialize.ts';
import { coalesce, isNotNull, isNull } from './null.ts';
import { doOp } from './sequence.ts';
import { fuzzy, prefix, reMatch } from './string-match.ts';
import { structOp } from './struct.ts';

export { validateColumnPath } from './col.ts';
export { defineFold } from './helpers.ts';

/**
 * All builtin top-level op schemas. Compose with extension ops via
 * `createOpTable`.
 */
export const builtins = [
  plus,
  minus,
  times,
  divide,
  mod,
  pow,
  abs,
  neg,
  round,
  floor,
  ceil,
  sqrt,
  log,
  exp,
  minOp,
  maxOp,
  lessThan,
  lessEq,
  greater,
  greaterEq,
  equals,
  notEquals,
  inOp,
  prefix,
  reMatch,
  fuzzy,
  and,
  or,
  not,
  isNull,
  isNotNull,
  coalesce,
  ifOp,
  caseOp,
  nullIf,
  def,
  letOp,
  fnOp,
  doOp,
  materializeOpForm,
  colOpForm,
  structOp,
] as const;
